import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import apiCall from "../../components/Api";
import contact from "../../assets/images/HealthSy/contact.png";
import newdelete from "../../assets/images/HealthSy/delete.png";
import search from "../../assets/images/searchIcon.png";
import AddButton from "../../components/Common/addButton";
import BackBtn from "../../components/Common/backBtn";
import Breadcrumbs from "../../components/Common/Breadcrumbs/Breadcrumbs";
import FilterOptions from "../../components/Common/filterOptions";
import NavBarTitles from "../../components/Common/TabBar";
import Deletepopup from "../../components/Modal/Deletepopup";

const MasterLegalPageType = () => {
  const navigate = useNavigate();

  const [id, setId] = useState("");
  const [skip, setSkip] = useState(0);
  const [, setPages] = useState(0);
  const [del, setDel] = useState(false);
  const [limit, setLimit] = useState(10);
  const [sort] = useState("newest");
  const [records, setRecords] = useState([]);
  const [current_page] = useState(1);
  const [filtered_records] = useState([]);

  useEffect(() => {
    list_api_call();
  }, [limit, sort, skip]);

  useEffect(() => {
    if (current_page > 1) {
      setSkip((current_page - 1) * limit);
    } else {
      setSkip(0);
    }
  }, [current_page]);

  const handlePlatformName = () => {
    navigate("/add-master-page-type");
  };

  const handleEdit = (id) => {
    navigate(`/edit-master-page-type/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const response = await apiCall(`page-type/delete/${id}`, "DELETE");

      if (response) {
        list_api_call();
        setDel(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleActive = async (id, status) => {
    try {
      await apiCall(`page-type/update/active/${id}`, "PATCH", {
        active: !status,
      });

      list_api_call();
    } catch (err) {
      console.error(err);
    }
  };

  const list_api_call = async () => {
    try {
      const response = await apiCall(`page-type/list`, "POST", {
        skip: skip,
        limit: limit,
        sort: sort,
      });
      setPages(Math.ceil(response.data.totalCount / Number(limit)));
      setRecords(response?.data?.rows);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <BackBtn navigatePath={`/app-download-link/website`} />
      <div className="healtharticle">
        <div className="healtharticle-container">
          <div className="healtharticle-title carrer-job-title ms-4">
            <Breadcrumbs
              breadcrumbText="Master"
              breadcrumbLink="#"
              nestedText="Common"
              nestedLink=""
              nestedText2="Legal Pages"
              nestedLink2=""
            />
          </div>

          <div className="healtharticle-addnew">
            <AddButton
              onClick={handlePlatformName}
              btnName="Add New Page Type"
            />
          </div>
          <NavBarTitles
            titles={[
              {
                name: "Platform Name",
                navigatePath: "/master-legal-pages",
              },
              {
                name: "Page Type",
                navigatePath: "/master-legal-page-type",
                className: "career-tab-jobpost career-gender",
              },
              {
                name: "Drafted By",
                navigatePath: "/master-legal-drafted-by",
              },
            ]}
          />

          <FilterOptions search={search} setLimit={setLimit} />

          <div className="healtharticle-table master-doctor-table">
            <table>
              <thead>
                <tr>
                  <td className="career-jobpost-td1">S.No</td>
                  <td className="career-jobpost-td2">Page Type</td>
                  <td className="career-jobpost-td3">Status</td>
                  <td className="career-jobpost-td12">Actions</td>
                </tr>
              </thead>
              <tbody>
                {(filtered_records.length > 0 ? filtered_records : records).map(
                  (el, i) => {
                    return (
                      <tr key={el._id}>
                        <td>{(current_page - 1) * limit + (i + 1)}</td>
                        <td>{el.page_name}</td>
                        <td>
                          {el.active === true ? "Verified" : "Not Verified"}
                        </td>
                        <td>
                          <span
                            className="master-edit  mx-2"
                            onClick={() => {
                              handleEdit(el._id);
                            }}
                          >
                            Edit
                          </span>
                          <span className="master-edit  mx-2-logo m-2">
                            <img src={contact} alt="" />
                          </span>
                          <span
                            className="text-primarycolor mx-2 cursor-pointer p-2"
                            onClick={() => {
                              handleActive(el._id, el.active);
                            }}
                          >
                            {el.active ? "Inactive" : "Active"}
                          </span>
                          <span className="text-primarycolor mx-2 cursor-pointer-icon">
                            <img src={newdelete} alt="" />
                          </span>
                          <span
                            className="text-primarycolor mx-2 cursor-pointer"
                            onClick={() => {
                              setId(el._id);
                              setDel(true);
                            }}
                          >
                            Delete
                          </span>
                          <span className="text-primarycolor mx-2 cursor-pointer-icon m-2">
                            <img src={newdelete} alt="" />
                          </span>
                        </td>
                      </tr>
                    );
                  },
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* <div className="mb-5 col d-flex pagination justify-content-end admin-pagination">
                <button
                    className="page-link"
                    disabled={skip === 0}
                >
                    <AiOutlineBackward size={20} />
                </button>
                <ReactPaginate
                    previousLabel="Previous"
                    nextLabel="Next"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    pageCount={pages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    containerClassName="pagination my-0"
                    activeClassName="active"
                    forcePage={pageOffset}
                />
                <button
                    className="page-link"
                    disabled={(skip / limit) === (pages - 1)}
                >
                    <AiOutlineForward size={20} />
                </button>
            </div> */}
      {del === true && <Deletepopup handleDelete={handleDelete} id={id} />}
    </>
  );
};

export default MasterLegalPageType;
